import { pxToRem } from 'utils/convert';
import { Tooltip } from 'ui/tooltip';
import { StyledSlideOverTooltipWrapper, XaiMonospacedTextWithTooltip } from '../Styled';
import { XaiMonospaceTextTooltipWrapperTypes } from './types';
import { useTextEllipsesTruncated } from '../../hooks/onTextEllipsesTruncated';
import { TEST_IDS } from '../../constants';

export const XaiMonospaceTextTooltipWrapper = ({
  name,
  children,
  $textMaxWidth,
  isEnabled,
}: XaiMonospaceTextTooltipWrapperTypes) => {
  const [hoverRef, isTruncatedText] = useTextEllipsesTruncated();
  const isTooltipEnabled = isEnabled || isTruncatedText;

  return (
    <div>
      <Tooltip tooltipContent={name} isEnabled={isTooltipEnabled}>
        <StyledSlideOverTooltipWrapper
          style={$textMaxWidth ? { maxWidth: `${$textMaxWidth}` } : { maxWidth: `${pxToRem(200)}` }}
          ref={hoverRef}
        >
          <XaiMonospacedTextWithTooltip data-test={TEST_IDS.XAITooltipWrapper}>
            {children}
          </XaiMonospacedTextWithTooltip>
        </StyledSlideOverTooltipWrapper>
      </Tooltip>
    </div>
  );
};
